import { render, staticRenderFns } from "./LeagueAdmin.vue?vue&type=template&id=1e82ffb3&"
import script from "./LeagueAdmin.vue?vue&type=script&lang=js&"
export * from "./LeagueAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports